export enum Integration {
  MPI = 'MPI',
  BASELINKER = 'BASELINKER',
  SHOPTET = 'SHOPTET',
  WEBEDI = 'WEBEDI',
}

export enum WorkflowStatus {
  REGISTRATION = 'REGISTRATION',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}

export type PartnerInfo = {
  partnerName?: string;
  integration: Integration;
  workflowStatus: WorkflowStatus;
  b2bSellModeEnabled: boolean;
};

export type PartnerInfoRequest = Omit<PartnerInfo, 'workflowStatus'>;

export type PartnerWorkflowStatusRequest = {
  workflowStatus: WorkflowStatus;
};

export type Partner = {
  id: number,
  code: string,
  name: string,
  integration: string,
  workflowStatus: WorkflowStatus,
  marketplaceCountTotal: number,
  marketplaceCountActive: number,
  webhook: string,
};

export type Webhook = {
  useWebhook: boolean;
  webhookUrl: string;
};

export type NextPartnerCode = {
  code: string;
};

export type PartnerCodeAvailability = {
  available: boolean;
};

export type PartnerCreateRequest = {
  code: string;
  partnerName: string;
  integration: Integration;
};

export type CreatedPartner = {
  code: string;
  partnerName: string;
  integration: Integration;
  apiToken: string;
};
